export function getAssetOrdersAfterReorder(
    assets: { order: number }[],
    sortResult: {
        removedIndex: number | null;
        addedIndex: number | null;
    },
) {
    if (sortResult.removedIndex === null || sortResult.addedIndex === null) {
        return assets;
    }
    const movedItem = assets[sortResult.removedIndex]!;
    assets.splice(sortResult.removedIndex, 1);
    assets.splice(sortResult.addedIndex, 0, movedItem);
    const data: { order: number }[] = [];

    for (let i = 0; i < assets.length; i++) {
        data.push({ ...assets[i], ...{ order: i } });
    }
    return data;
}
